import { PDFDocument, rgb, degrees, StandardFonts } from 'pdf-lib';

export interface IAnonymizeOptions {
  watermarkText?: string;
  applyBlackoutHeader?: boolean;
  applyBlackoutFooter?: boolean;
  customWatermark?: boolean;
}

/**
 * Aplica anonimização LGPD e marca d'água de confidencialidade no PDF
 */
export async function applyAnonymizationToPdf(
  pdfBuffer: ArrayBuffer,
  options: IAnonymizeOptions
): Promise<Uint8Array> {
  const pdfDoc = await PDFDocument.load(pdfBuffer, { ignoreEncryption: true });
  const pages = pdfDoc.getPages();
  const font = await pdfDoc.embedFont(StandardFonts.HelveticaBold);

  pages.forEach((page) => {
    const { width, height } = page.getSize();

    // 1. Marca d'Água de Segurança (LGPD / Confidencial)
    if (options.watermarkText) {
      page.drawText(options.watermarkText.toUpperCase(), {
        x: width / 6,
        y: height / 2.5,
        size: 32,
        font,
        color: rgb(0.8, 0.2, 0.2),
        opacity: 0.18,
        rotate: degrees(45),
      });
    }

    // 2. Tarja Preta no Cabeçalho (dados sensíveis de identificação superior)
    if (options.applyBlackoutHeader) {
      page.drawRectangle({
        x: 40,
        y: height - 60,
        width: width - 80,
        height: 35,
        color: rgb(0, 0, 0),
        opacity: 1,
      });

      page.drawText('[DADOS ANONIMIZADOS - CONFORMIDADE LGPD]', {
        x: 45,
        y: height - 48,
        size: 8,
        font,
        color: rgb(1, 1, 1),
      });
    }

    // 3. Tarja Preta no Rodapé (dados bancários / assinaturas não-eletrônicas)
    if (options.applyBlackoutFooter) {
      page.drawRectangle({
        x: 40,
        y: 40,
        width: width - 80,
        height: 35,
        color: rgb(0, 0, 0),
        opacity: 1,
      });

      page.drawText('[DADOS PESSOAIS PROTEGIDOS - LEI Nº 13.709/2018]', {
        x: 45,
        y: 52,
        size: 8,
        font,
        color: rgb(1, 1, 1),
      });
    }
  });

  return await pdfDoc.save();
}
